// import { useState } from "react";

import Header from "../../helperComponents/Header/header";
import './home.scss';
import scrollCta from '../../assets/homepageScrollCTA.svg';
import { useMediaQuery } from "react-responsive";
import { useState, useEffect } from "react";
import Button from "../../helperComponents/Button/Button";
import { Splide, SplideTrack, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import '@splidejs/react-splide/css/skyblue';
import '@splidejs/react-splide/css/sea-green';
import '@splidejs/react-splide/css/core';
import { IoIosArrowForward } from "react-icons/io";
import PreFooter from "../../helperComponents/PreFooter/Prefooter";
import Footer from "../../helperComponents/Footer/Footer";
import gsap from 'gsap';
import { TextPlugin } from "gsap/TextPlugin";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SplitType from 'split-type';
import { FallingLines } from 'react-loader-spinner'
import DuduElement from "../../helperComponents/DuduElement/duduElement";


export default function Home() {
    const isMediumScreen = useMediaQuery({ query: '(max-width: 850px)' });
    const isAlmostMediumScreen = useMediaQuery({ query: '(max-width: 1212px)' });

    const videoUrl = "https://res.cloudinary.com/dqgtosjsg/video/upload/v1737931249/Untitled_video_-_Made_with_Clipchamp_3_lm7ybu.mp4".replace('/upload/', '/upload/q_auto,f_auto/');
    const gallery1 = 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1740773262/AdunTemi-3200_n1eydd.jpg'.replace('/upload/', '/upload/q_auto,f_auto,w_1200/');
    const gallery2 = ' https://res.cloudinary.com/dqgtosjsg/image/upload/v1740773263/AdunTemi-3374_np0jaj.jpg'.trim().replace('/upload/', '/upload/q_auto,f_auto,w_1200/');
    const gallery3 = 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1740773262/NICCEA-1113-2_avidz4.jpg'.replace('/upload/', '/upload/q_auto,f_auto,w_1200/');
    gsap.registerPlugin(TextPlugin);
    gsap.registerPlugin(ScrollTrigger);

    const testimonialArray = [
        {
            testimonial: `Working with Dudu's World of Entertainment was an absolute pleasure! Their attention to detail and creativity truly brought our vision to Fruition`,
            image: "https://res.cloudinary.com/dqgtosjsg/image/upload/v1740602583/NIK_2758_l3f8hv.jpg".replace('/upload/', '/upload/q_auto,f_auto,w_800/'),
            name: 'Gbenga',
            place: 'Toronto, Canada.'
        },
        {
            testimonial: 'She tailored everything exactly how I wanted it. I had the best birthday party, thanks to Dudu!',
            image: 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1740602535/gallery5_cfhlm3.jpg'.replace('/upload/', '/upload/q_auto,f_auto,w_800/'),
            name: 'Dara',
            place: 'Toronto, Canada.'
        }, {
            testimonial: `Their creativity and attention to detail were apparent in every aspect of the event, and we couldn't have been happier with the results.`,
            image: 'https://res.cloudinary.com/dqgtosjsg/image/upload/v1740602491/NIK_6058_qh1gtj.jpg'.replace('/upload/', '/upload/q_auto,f_auto,w_800/'),
            name: 'Abe',
            place: 'Toronto, Canada.'
        },
    ]

    const [isAssetsLoaded, setIsAssetsLoaded] = useState(false);


    useEffect(() => {
        setTimeout(() => {
            const video = document.createElement('video');
            video.src = videoUrl;

            const handleCanPlayThrough = () => setIsAssetsLoaded(true);
            const handleError = () => setIsAssetsLoaded(false);

            // Add event listeners
            video.addEventListener('canplaythrough', handleCanPlayThrough);
            video.addEventListener('error', handleError);

            if (isMediumScreen) {
                if (!isAssetsLoaded) {
                    setTimeout(() => {
                        setIsAssetsLoaded(true);
                    }, 15000);
                }
            }

            // Cleanup function
            return () => {
                video.removeEventListener('canplaythrough', handleCanPlayThrough);
                video.removeEventListener('error', handleError);
            };
        }, 3000);

        let revelation2 = document.querySelectorAll(".revelation2");
        new SplitType('.Herotext1');
        const tl1 = gsap.timeline();

        let tlfirstSection = gsap.timeline({
            scrollTrigger: {
                trigger: '.postHero--cont2',
                scrub: 1,
                start: "-40% center",
                end: "20% center",
            }
        });

        revelation2.forEach((container) => {
            let tlText1 = gsap.timeline({
                scrollTrigger: {
                    trigger: '.postHero--cont2',
                    scrub: 1,
                    start: "-60% center",
                    end: "45% center",
                }
            });

            tlText1
                .fromTo('.revelation2_container', {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.5,
                    ease: "power2.inOut"
                })
                .fromTo(container, {
                    x: -50,
                    opacity: 0
                }, {
                    x: 0,
                    opacity: 1,
                    duration: 1.8,
                    stagger: { amount: 0.1 },
                    ease: "power4.inOut"
                })
                .fromTo('.revelation24', {
                    y: 50,
                    opacity: 0
                }, {
                    y: 0,
                    opacity: 1,
                    duration: 0.8,
                    stagger: { amount: 0.1 },
                    ease: "power2.inOut"
                });
        });

        tlfirstSection.to('.revelation11', {
            duration: 1,
            y: 0,
            ease: "power4.inOut",
            opacity: 1,
            stagger: {
                amount: 0.3
            }
        })

        tl1.to(".homeContainer--hero--div1", {
            duration: 1,
            opacity: 1,
            ease: "power3.out",
            stagger: {
                amount: 0.5
            }
        }).to(".Herotext1", {
            duration: 1,
            y: 0,
            height: "fit-content",
            ease: "power4.inOut",
            opacity: 1,
            stagger: {
                amount: 0.3
            }
        }).to(".char", {
            duration: .7,
            y: 0,
            ease: "power4.inOut",
            stagger: {
                amount: 0.3
            }
        })
            .to(".Herotext2", {
                duration: 1,
                ease: "power1.out",
                x: 0,
                opacity: 1,
                stagger: {
                    amount: 0.3
                }
            },).to(".heroHeader", {
                duration: 1,
                opacity: 1,
                ease: "power1.out",
                stagger: {
                    amount: 0.3
                }
            }, "-=2.5");

        let tlText3 = gsap.timeline({
            scrollTrigger: {
                trigger: '.gallery-services',
                scrub: 1,
                start: "0% center",
                end: "20% center",
            }
        });

        tlText3.to(".revelation4", {
            duration: 1,
            opacity: 1,
            delay: .8,
            ease: "power1.out",
            y: 0,
            height: 'fit-content',
            stagger: {
                amount: 0.3
            }
        });

        let tlText4 = gsap.timeline({
            scrollTrigger: {
                trigger: '.testimonial-services',
                scrub: 1,
                start: "0% center",
                end: "20% center",
            }
        });

        tlText4.to(".revelation5", {
            duration: 1,
            opacity: 1,
            ease: "power1.out",
            y: 0,
            height: 'fit-content',
            stagger: {
                amount: 0.3
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAssetsLoaded]);

    return (
        isAssetsLoaded ? <div className="homeContainer">
            <div className="homeContainer--hero">
                <video
                    className="video-background"
                    autoPlay
                    loop
                    muted
                    webkit-playsinline
                    preload="auto"
                    playsInline
                >
                    <source
                        src={videoUrl}
                        type="video/mp4"
                    />
                </video>
                <div className="content-overlay">
                    <div className="heroHeader"><Header isHomepage={true} /></div>
                    <div className="homeContainer--hero--div1" style={{ color: '#FBF4E5', }}>
                        <p className="Herotext1">Crafting Memorable Experiences</p>
                        <p className="Herotext2">
                            we specialize in crafting memorable experieneces
                            that last a lifetime. With a passion for creativity and an unwavering commmittment
                            to excellence, we transform your dreams into reality.
                        </p>
                    </div>
                    <div className="homeContainer--hero--div2" style={{ color: '#FBF4E5' }}>
                        <div style={{ width: 'fit-content', cursor: 'pointer', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <img src={scrollCta} alt="homepage scroll CTA for dudu's world" width={39} />
                            <p>Scroll Down</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="postHero">
                <div className="postHero--cont1" style={{ display: 'flex', justifyContent: "space-between", alignItems: 'start', gap: '24px', flexWrap: 'wrap', color: '#916859', marginBottom: '100px' }}>
                    <div className="postHero--cont11" style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', gap: '8px', flexWrap: 'nowrap' }}>
                        <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#916859' }}></div>
                        <p className="revelation11" style={{ fontSize: '14px', lineHeight: "5px", fontWeight: 400, }}>ABOUT</p>
                    </div>

                    <div className="postHero--cont12">
                        <p className="revelation1 revelation11">
                            At Dudu&apos;s World of Entertainment we are more  than just event planners,
                            <span style={{ fontStyle: 'italic' }}>we are great storytellers.</span>
                        </p>
                    </div>
                </div>

                <div className="postHero--cont2" style={{ display: 'flex', gap: '20px', flexDirection: isMediumScreen ? 'column' : 'row' }}>
                    <div className="revelation2_container" style={{ flex: 1 }}>
                        <img
                            className="revelation2 revelation22"
                            style={{ width: '100%', }}
                            src={'https://res.cloudinary.com/dqgtosjsg/image/upload/v1737640171/posthero1_o19qqw.jpg'}
                            alt="Dudu's world hosting a birthday bash." />
                    </div>
                    <div className="revelation2_container" style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '50px', color: '#916859' }}>
                        <img className="revelation2 revelation23" style={{ width: '100%' }} src={'https://res.cloudinary.com/dqgtosjsg/image/upload/v1737640191/posthero2_breqxh.jpg'} alt="Dudu's world hosting a birthday bash." />
                        <p className="revelation24" style={{ fontSize: isMediumScreen ? '15px' : '20px', lineHeight: isMediumScreen ? '22px' : '28px' }}>Whether you're planning an intimate gathering or a grand celebration,
                            our team of dedicated professionals is here to guide you through every step of the journey.
                            From concept to execution, we pride ourselves on our attention to detail, personalized service,
                            and innovative approach to event design.
                        </p>
                        <Button text={'More About Us'} route={'/about'} />
                    </div>
                </div>
            </div>

            <DuduElement />

            <div className="gallery-services" style={{ color: '#916859', }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', flexWrap: isAlmostMediumScreen ? 'wrap' : 'nowrap', width: '100%' }}>
                    <div className="revelation4 gallery-services--cont11" style={{ display: 'flex', width: 'fit-content', alignItems: 'start', gap: '8px', flexWrap: 'nowrap', marginBottom: isMediumScreen ? '50px' : 0, }}>
                        <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#916859' }}></div>
                        <p style={{ fontSize: '14px', lineHeight: "5px", fontWeight: 400, whiteSpace: 'nowrap', }}>OUR GALLERY</p>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <p className=" revelation4 gallery-services--cont12" style={{ marginBottom: '50px', width: isMediumScreen ? '100%' : '784px' }}>
                            Explore our Gallery to discover the <span style={{ fontStyle: 'italic' }}>magic we've created for our clients.</span>
                            <span className="gallery-services--cont12--span" style={{ marginBottom: '50px', fontSize: '20px', lineHeight: '30px', display: 'block', marginTop: '50px', }}>
                                From enchanting weddings to corporate extravaganzas, each event showcases our commitment to excellence and attention to detail.
                            </span>
                        </p>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'start', gap: '16px', width: '100%', flexWrap: isMediumScreen ? 'wrap' : "nowrap", marginBottom: '50px' }}>
                    <img src={gallery1} alt="gallery item 1" style={{ flex: 1, objectFit: 'cover', height: 'auto', width: isMediumScreen ? '100%' : '33%' }} />
                    <img src={gallery3} alt="gallery item 3" style={{ flex: 1, objectFit: 'cover', height: 'auto', width: isMediumScreen ? '100%' : '33%', }} />
                    <img src={gallery2} alt="gallery item 2" style={{ flex: 1, objectFit: 'cover', height: 'auto', width: isMediumScreen ? '100%' : '33%' }} />
                </div>

            </div>


            <div className="testimonial-services" style={{ color: '#916859', }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', flexWrap: isAlmostMediumScreen ? 'wrap' : 'nowrap', width: '100%' }}>
                    <div className="revelation5 testimonial-services--cont11" style={{ display: 'flex', width: 'fit-content', alignItems: 'start', gap: '8px', flexWrap: 'nowrap', marginBottom: isMediumScreen ? '50px' : 0, }}>
                        <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#916859', }}></div>
                        <p style={{ fontSize: '14px', lineHeight: "5px", fontWeight: 400, whiteSpace: 'nowrap', }}>CLIENT TESTIMONIALS</p>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <p className="revelation5 testimonial-services--cont12" style={{ marginBottom: isMediumScreen ? '15px' : '50px', width: isMediumScreen ? '100%' : '784px' }}>
                            Don't just take our word for it. Take a <span style={{ fontStyle: 'italic' }}>look at what our clients have to say.</span>
                            <span className="testimonial-services--cont12--span" style={{ marginBottom: '50px', fontSize: '20px', lineHeight: '30px', display: 'block', marginTop: '50px', }}>
                                We are trusted by a lot of special people and we have proof to back it up.
                            </span>
                        </p>
                    </div>
                </div>
                <Splide options={{
                    rewind: true,
                    width: '100%',
                    gap: isAlmostMediumScreen ? "1em" : '2rem',
                    perPage: isAlmostMediumScreen ? 1 : 3,
                    perMove: 1,
                }} hasTrack={false} aria-label="...">
                    <SplideTrack>
                        {
                            testimonialArray.map((test) => (
                                <SplideSlide className="splide_slide" style={{ padding: isAlmostMediumScreen ? "21px" : '43px 48px', background: '#EFE9DB', }}>
                                    <div>
                                        <p style={{ fontWeight: 600, fontSize: '20px', lineHeight: '28px', marginBottom: '85px' }}>&apos;&apos; {test.testimonial} &apos;&apos;
                                        </p>
                                        <div className="testimonial_div" >
                                            <div
                                                style={{
                                                    width: 61,
                                                    height: 61,
                                                    backgroundImage: `url(${test.image})`,
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center',
                                                    backgroundRepeat: 'no-repeat',
                                                    borderRadius: '50%',
                                                }}
                                                alt='Dudu world photos showcasing them in different events.'
                                            ></div>
                                            <div className="testimonial_div2">
                                                <p className="testimonial_name">{test.name}</p>
                                                <p>{test.place}</p>
                                            </div>
                                        </div>
                                    </div>
                                </SplideSlide>
                            ))
                        }
                    </SplideTrack>

                    <div className="splide__arrows" style={{ width: isMediumScreen ? '35%' : isAlmostMediumScreen ? '20%' : '15%', position: 'absolute', marginTop: '100px', display: 'flex', right: '2em' }}>
                        <div className="splide__arrow splide__arrow--prev" ><IoIosArrowForward /></div>
                        <div className="splide__arrow splide__arrow--next"><IoIosArrowForward /></div>
                    </div>
                </Splide>
            </div>
            <PreFooter />
            <Footer />
        </div>
            :
            <div className="loadingAssets" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw', flexDirection: 'column' }}>
                <FallingLines
                    height="80"
                    width="100"
                    radius="9"
                    color="#e5beaf"
                    ariaLabel="loading"
                    wrapperStyle
                    wrapperClass
                />
                <p>loading this magic...</p>
            </div>
    )
}